module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-secondary btn",
    attrs: {
      "label": "Print",
      "icon": "pi pi-print"
    },
    on: {
      "click": _vm.generateReport
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger btn",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.back()
      }
    }
  })], 1)]), _vm._v(" "), _c('Card', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('div', {
          staticClass: "p-grid"
        }, [_c('div', {
          staticClass: "p-col-2"
        }, [_c('span', {
          staticClass: "logo-mini"
        }, [_c('a', {
          attrs: {
            "href": ""
          }
        }, [_c('img', {
          staticClass: "img-responsive center-block logo",
          attrs: {
            "src": _vm.$store.state.organisationLogo,
            "alt": "Logo"
          }
        })])])]), _vm._v(" "), _c('div', {
          staticClass: "p-col-6",
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('h3', [_c('b', [_vm._v(_vm._s(_vm.organisationName))])])])]), _vm._v(" "), _c('div', {
          staticClass: "p-grid"
        }, [_c('div', {
          staticClass: "p-col-2"
        }), _vm._v(" "), _c('div', {
          staticClass: "p-col-6",
          staticStyle: {
            "margin-top": "-1%",
            "text-align": "-webkit-center"
          }
        }, [_c('h4', [_vm._v(_vm._s(_vm.organisationPanVatNo))])]), _vm._v(" "), _c('div', {
          staticClass: "p-col-4"
        })]), _vm._v(" "), _c('div', {
          staticClass: "p-grid"
        }, [_c('div', {
          staticClass: "p-col-2"
        }), _vm._v(" "), _c('div', {
          staticClass: "p-col-6",
          staticStyle: {
            "margin-top": "-1%",
            "text-align": "-webkit-center"
          }
        }, [_c('h4', [_vm._v(_vm._s(_vm.organisationAddress))])]), _vm._v(" "), _c('div', {
          staticClass: "p-col-4"
        })]), _vm._v(" "), _c('div', {
          staticClass: "p-grid"
        }, [_c('div', {
          staticClass: "p-col-2"
        }), _vm._v(" "), _c('div', {
          staticClass: "p-col-6"
        }, [_c('h5', {
          staticStyle: {
            "margin-top": "-1%",
            "text-align": "-webkit-center"
          }
        }, [_vm._v(_vm._s(_vm.organisationContact))])]), _vm._v(" "), _c('div', {
          staticClass: "p-col-4"
        })]), _vm._v(" "), _c('div', {
          staticClass: "p-grid"
        }, [_c('div', {
          staticClass: "p-col-4"
        }, [_c('h3', [_c('b', [_vm._v(_vm._s(_vm.voucherType))])])]), _vm._v(" "), _c('div', {
          staticClass: "p-col-6"
        }), _vm._v(" "), _c('div', {
          staticClass: "p-col-2"
        })]), _vm._v(" "), _c('div', {
          staticClass: "p-grid"
        }, [_c('div', {
          staticClass: "p-col-4",
          staticStyle: {
            "margin-top": "-1%"
          }
        }, [_c('h4', [_vm._v("Voucher No:- " + _vm._s(_vm.voucherNo))])]), _vm._v(" "), _c('div', {
          staticClass: "p-col-4"
        }), _vm._v(" "), _c('div', {
          staticClass: "p-col-4"
        }, [_c('label', [_vm._v("Date: " + _vm._s(_vm.nepaliDate) + _vm._s(_vm.englishDate))])])]), _vm._v(" "), _c('table', {
          staticClass: "table table-bordered"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v("Account")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v("Debit")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v("Credit")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v("Cheque Date")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v("Cheque Number")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v("Short Narration")])])]), _vm._v(" "), _vm._l((_vm.voucherList), function(account, index) {
          return _c('tbody', {
            key: index
          }, [_c('tr', [_c('td', [_vm._v(_vm._s(account.accountMaster.name))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "right",
              "color": "#00a65a"
            }
          }, [_vm._v(_vm._s(account.drCr == 'D' ? account.txnAmount : ''))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "right",
              "color": "#dd4b39"
            }
          }, [_vm._v(_vm._s(account.drCr == 'C' ? account.txnAmount : '') + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.chequeDate) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.chequeNumber) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.narration3) + " ")])])])
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "p-grid"
        }, [_c('div', {
          staticClass: "p-col-6"
        }, [_c('strong', [_vm._v("Narration: " + _vm._s(_vm.narration))])]), _vm._v(" "), _c('div', {
          staticClass: "p-col-6"
        })]), _vm._v(" "), _c('div', {
          staticClass: "p-grid"
        }, [_c('div', {
          staticClass: "p-col-6",
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('strong', [_vm._v("Prepared By: " + _vm._s(_vm.userName))])]), _vm._v(" "), _c('div', {
          staticClass: "p-col-2"
        }), _vm._v(" "), _c('div', {
          staticClass: "p-col-4",
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('strong', [_vm._v("Approved By: ..............................")])])])]
      },
      proxy: true
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b9a7a1f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/commonDialogs/voucher.vue
// module id = 2110
// module chunks = 0